<template>
  <span>
    <img v-if="!isDarkMode" src="@/assets/kinectin-logo.png" alt="Loading" class="logo" :style="logoStyle"/>
    <img v-if="isDarkMode" src="@/assets/kinectin-logo-dm.png" alt="Loading" class="logo" :style="logoStyle"/>
  </span>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue'
import { useTheme } from 'vuetify'

const props = defineProps({
  size: { type: String, default: '50px' },
  forceLightMode: { type: Boolean },
  speed: {type: Number, default: 7},
})

const theme = useTheme()
const isDarkMode = computed(() => props.forceLightMode ? false : theme.global.name.value === 'dark')

const rotation = ref(0)
const logoStyle = computed(() => ({
  transform: `rotate(${rotation.value}deg)`,
  width: props.size,
  height: props.size,
}))

const animateSpin = () => {
  rotation.value = (rotation.value + props.speed) % 360; // Ensures smooth continuous rotation
  requestAnimationFrame(animateSpin);
}

onMounted(() => {
  requestAnimationFrame(animateSpin);
})
</script>

<style scoped>
.logo {
  transition: transform 0s linear;
}
</style>
